'use client';

import type { ICollectionPipelineStatusV3 } from '@repo/sdk';
import type { JSX } from 'react';
import { PipelineStepCell } from '../pipeline-step-cell';
import { PipelineStepDialog } from '../pipeline-step-dialog';
import { PipelineStepPlainCountBadge } from '../pipeline-step-plain-count-badge';

interface IManualStepProps {
  item: ICollectionPipelineStatusV3;
}

export function ManualStep({ item }: IManualStepProps): JSX.Element {
  const { clipsManual } = item.steps;

  return (
    <PipelineStepCell
      badge={<PipelineStepPlainCountBadge step={clipsManual} />}
      renderDialog={(open, onOpenChange) => (
        <PipelineStepDialog
          open={open}
          onOpenChange={onOpenChange}
          title="Manual clips"
          description={`Manually-created clips. Independent of the pipeline. Never auto-deleted by Match, Extract, or Clip force-rerun. Delete one-by-one via clip triage. ${clipsManual.count} manual clip(s).`}
          dataHref={`/sys/challenges?collectionId=${item.collectionId}&source=manual`}
          dataLabel="Open linked challenges"
        />
      )}
    />
  );
}
